import React from 'react';
import TitleWithLine from './titleWithLine';
import SectionSummary from './sectionSummary';
import { Grid, Typography } from '@mui/material';
import LabelValue from './labelValue';
import {splitDateTime} from '../../util/helpers'
import dayjs from 'dayjs'
import { useTranslation } from "react-i18next";

const SummaryContent = ({guestDetail}) => {
  const { t } = useTranslation();
  const selectedActivity = 
        guestDetail.Snorkeling_Package__c && guestDetail.Diving_Package__c
          ? 'both'
          : guestDetail.Snorkeling_Package__c
          ? 'snorkelling'
          : guestDetail.Diving_Package__c
          ? 'diving'
          : '-';
  const formatDate = (date) => {
  const parsedDate = dayjs(date);
    if(!date) return '-'
    return parsedDate.isValid() ? parsedDate.format('DD/MMM/YYYY').toUpperCase() : '-';
  };
  function capitalizeWord(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  const formatTime = (time) => {
    console.log(time)
    if(!time) return '-'
    const parsedTime = dayjs(time, 'HH:mm:ss');
    return parsedTime.isValid() ? parsedTime.format('HH:mm') : '-';
  };

  return (
    <div style={{padding: '10px 0'}}>
      <TitleWithLine title={t("Personal Information")} style={{marginTop: '10px'}}/>
      <SectionSummary title={t("About You")}>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("First Name")} value={guestDetail.First_Name__c || '-'} />
            <LabelValue label={t("Middle Name")} value={guestDetail.Middle_Name__c || '-'} />
            <LabelValue label={t("Last Name")} value={guestDetail.Last_Name__c || '-'} />
            <LabelValue label={t("Salutation")} value={guestDetail.Salutation__c || '-'} />
            <LabelValue label={t("Preferred/Given Name")} value={guestDetail.Nick_Name__c || '-'} />
            <LabelValue label={t("Date of Birth")} value={formatDate(guestDetail.Birthdate__c)} />
            <LabelValue label={t("Gender")} value={guestDetail.Guest_Gender__c || '-'} />
        </Grid>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Nationality")} value={guestDetail.Nationality__c || '-'} />
            <LabelValue label={`${t('Passport')} #`} value={guestDetail.Passport_Number__c || '-'} highlight={!guestDetail.Passport_Number__c}/>
            <LabelValue label={t("Passport Expiry Date")} value={formatDate(guestDetail.Passport_Expiry_Date__c)} />
            <LabelValue label={t("Email Address")}  value={guestDetail.Email_Guest__c || '-'} />
            <LabelValue label={t("Repeat Email Address")} value={guestDetail.Email_Guest__c || '-'} />
            <LabelValue label={t("Home Tel")} value={guestDetail.Home_Tel__c || '-'} />
            <LabelValue label={t("Mobile Tel")}  value={guestDetail.Mobile_Tel__c || '-'} />
        </Grid>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
            label={t("How did you find us?" )}
            value={guestDetail.How_did_you_find_us__c || '-'}
            stacked />
        </Grid>
      </SectionSummary>
      <SectionSummary title={t("Address")}>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Country")} value={guestDetail.Mailing_Country__c || '-'} />
            <LabelValue label={t("City")} value={guestDetail.Mailing_City__c || '-'} />
            <LabelValue label={t("State or Province")} value={guestDetail.Mailing_State_Province__c || '-'} />
        </Grid>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Street Address")} value={guestDetail.Mailing_Street__c || '-'} />
            <LabelValue label={t("Postal code / Zip")} value={guestDetail.Mailing_Zip_Postal_Code__c || '-'} />
        </Grid>
      </SectionSummary>
      <SectionSummary title={t("Contact & Emergency Contact")}>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Emergency Contact Name")}  value={guestDetail.Emergency_Contact__c || '-'} />
        </Grid>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Telephone")} value={guestDetail.Emergency_Tel__c || '-'} />
        </Grid>
      </SectionSummary>
      <TitleWithLine title={t("Snorkelling / Diving Preferences")} />
      <SectionSummary title={t("Activity Package")}>
        <Grid item xs={6} sx={{padding: '8px 0 !important'}}>
           <Typography component="span" sx={{ fontSize: '14px' }}>
            { t(capitalizeWord(selectedActivity)) }
           </Typography>
        </Grid>
      </SectionSummary>

      {
        ['snorkelling', 'both'].includes('both') &&
        <SectionSummary title={t("Snorkelling")}>
          <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
              label={t("How do you describe yourself as a snorkeller?")}
              value={guestDetail.Snorkeler_Description__c || '-'} 
              stacked />
          </Grid>
          <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
              label={t("How would you describe your snorkelling style?")} 
              value={guestDetail.Snorkling_Style__c || '-'} 
              stacked />
          </Grid>
          <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
              label={t("What equipment would you like to rent, if any?" )}
              value={guestDetail.Snorkeling_Equipment_Rental__c || '-'} 
              stacked />
          </Grid>
        </SectionSummary>
      }

      {
        ['diving', 'both'].includes('both') &&
        <SectionSummary title={t("Diving")}>
          <Grid item xs={6} sx={{padding: '0 !important'}}>
              <LabelValue label={t("Number of Dives")} value={guestDetail.Number_of_Dives__c || '-'} />
              <LabelValue label={`${t("What year did you start diving")}?`} value={Math.round(guestDetail.Diving_Start_Year__c) || '-'} />
              <LabelValue label={`${t("Dives per year")}?`} value={guestDetail.No_of_days_diving_per_year__c || '-'} />
              <LabelValue label={`${t("Nitrox Requested")}?`} value={guestDetail.Nitrox_Requested__c ? 'yes' : 'no'} />
              <LabelValue label={t("Desired Tank Size")} value={guestDetail.Tank_size__c || '-'} />
              <LabelValue label={t("Certification Agency")} value={guestDetail.Certification_Agency__c || '-'} />
              <LabelValue label={t("Certification Level")} value={guestDetail.Certification_Level__c || '-'} />
          </Grid>
          <Grid item xs={6} sx={{padding: '0 !important'}}>
              <LabelValue label={t("Certification Number")} value={guestDetail.Certification_Number__c || '-'} />
              <LabelValue label={t("Nitrox Agency")} value={guestDetail.Nitrox_Agency__c || '-'} />
              <LabelValue label={t("Nitrox Certification Number")} value={guestDetail.Nitrox_Certificate__c || '-'} />
              <LabelValue label={t("Diving Insurance Agency")} value={guestDetail.Diving_Insurance_Agency__c || '-'} />
              <LabelValue label={t("Diving Insurance Number")} value={guestDetail.Diving_Insurance_Number__c || '-'} />
              <LabelValue label={`${t("Underwater Camera")}?`} value={guestDetail.Underwater_Camera__c || '-'} />
          </Grid>
          <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
              label={`${t("How would you describe your diving style")}?`}
              value={guestDetail.Dive_Style__c || '-'} 
              stacked />
          </Grid>
          <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
              label={`${t("When was your last dive")}?`} 
              value={guestDetail.Last_Dive__c} 
              stacked />
          </Grid>
          <Grid item xs={12} sx={{padding: '0 !important'}}>
            <LabelValue 
              label={`${t("What equipment would you like to rent, if any")}?`} 
              value={guestDetail.Diving_Equipment_Rental__c || '-'} 
              stacked />
          </Grid>
        </SectionSummary>
      }
      <TitleWithLine title={t("Stay Preferences")} />
      <SectionSummary title={t("Arrival")}>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
           <LabelValue 
            label={t("Check-In Date")} 
            value={formatDate(guestDetail.Check_In__c)} 
            stacked />
        </Grid>
      </SectionSummary>
      <SectionSummary title={t("Preferences")}>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
           <LabelValue 
            label={t("Dietary Requirements")} 
            value={guestDetail.Dietary_Requirements__c || '-'} 
            stacked />
        </Grid>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
           <LabelValue 
            label={t("Bedding Configuration")}
            value={t(guestDetail.Bed_configuration_preference__c) || '-'}
            stacked />
        </Grid>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
           <LabelValue 
            label={`${t("Any other special requests for the Resort")}?`} 
            value={guestDetail.Any_other_special_request_for_the_resort__c || '-'} 
            stacked />
        </Grid>
      </SectionSummary>

      <TitleWithLine title={t("Flight and Other Requests")} />
      <SectionSummary title={t("Flight Details")}>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
           <LabelValue 
            label={`${t("Who are you updating the flight information for")}?`}
            value={guestDetail.Update_For__c === 'Companions' ? 
              t('For myself and travelling companions') : t('For myself only')}
            stacked />
        </Grid>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Date of Arrival in Bali")} value={formatDate(splitDateTime(guestDetail.Arrival_Date_Time__c,'date')) || '-'} />
            <LabelValue label={t("Time Arrival")} value={formatTime(splitDateTime(guestDetail.Arrival_Date_Time__c,'time')) || '-'} />
            <LabelValue label={`${t("Arrival Flight")} #`} value={guestDetail.Arrival_Flight_No__c || '-'} />
            <LabelValue label={t("Hotel Name")} value={guestDetail.Arrival_Hotel__c || '-'} />
        </Grid>
        <Grid item xs={6} sx={{padding: '0 !important'}}>
            <LabelValue label={t("Departure Date from Bali")} value={formatDate(splitDateTime(guestDetail.Departure_Date_Time_back_home__c,'date')) || '-'} />
            <LabelValue label={t("Time Departure")} value={formatTime(splitDateTime(guestDetail.Departure_Date_Time_back_home__c,'time')) || '-'} />
            <LabelValue label={`${t("Departure Flight")} #`} value={guestDetail.Departure_Flight_No__c || '-'} />
            <LabelValue label={t("Travel Agent or Contact Person")} value={guestDetail.My_travel_agent__c || '-'} />
        </Grid>
        <Grid item xs={12} sx={{padding: '0 !important'}}>
           <LabelValue label={t("Weight")} value={guestDetail.Estimated_Luggage_Weight__c || '-'} stacked/>
           <LabelValue 
            label={`${t("Any other special requests for the Bali office?")}`} 
            value={guestDetail.Any_other_special_requests_for_our_Bali__c || '-'} 
            stacked />
        </Grid>
      </SectionSummary>
      <TitleWithLine title={t("Agreement")} color='#5165D6' lineColor='#7087F9'/>

    </div>
  );
};

export default SummaryContent;